import SupplierEvent, { SupplierEventStatus, SupplierEventPublishedState, SupplierEventType } from "@/features/SupplierEvents/SupplierEvent";
import SupplierEventProductRequestModel from "@/features/SupplierEvents/RequestModels/SupplierEventProductRequestModel";
import UploadedPlatformDocumentMetadata from "@/features/PlatformDocuments/UploadedPlatformDocumentMetadata";

export default class SupplierEventRequestModel {
    id: string | null = null;
    status: SupplierEventStatus = SupplierEventStatus.New;
    publishedState: SupplierEventPublishedState = SupplierEventPublishedState.InProgress;
    type: SupplierEventType = SupplierEventType.PriceEvent;
    supplierID: string | null = null;
    products: SupplierEventProductRequestModel[] | null = null;
    plantLocation: string | null = null;
    countryID: string | null = null;
    reason: string | null = null;
    startDate: Date | null = null;
    endDate: Date | null = null;
    leadTimeImpactDays: number | null = null;
    comments: string | null = null;
    uploadedPlatformDocumentMetadatas: UploadedPlatformDocumentMetadata[] | null = null;
    platformDocumentMetadataIDs: string[] | null = null;

    constructor(event: SupplierEvent) {
        this.id = event.id;
        this.status = event.status;
        this.publishedState = event.publishedState;
        this.type = event.type;
        this.supplierID = event.supplierID;
        this.products = event.products.map(p => new SupplierEventProductRequestModel(p));
        this.plantLocation = event.plantLocation;
        this.countryID = event.countryID;
        this.reason = event.reason;
        this.startDate = event.startDate;
        this.endDate = event.endDate;
        this.leadTimeImpactDays = event.leadTimeImpactDays;
        this.comments = event.comments;
        this.uploadedPlatformDocumentMetadatas = event.uploadedPlatformDocumentMetadatas;
        this.platformDocumentMetadataIDs = event.platformDocumentMetadataIDs;
    }
}
